import * as React from 'react';

import {Nut_Settings_User} from 'nutshell-core/settings-constants';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

import type {GetSessionUser_loggedInUser as User} from 'nutshell-graphql-types';

import {useUpdateUserSetting} from '../../../core/use-update-user-setting';

import {analyticsClient} from '../../../../analytics-client';

type Props = {
    user: User;
};

export function FollowUpTasksOnboardingModalBody(props: Props) {
    const {user} = props;
    const updateUserSetting = useUpdateUserSetting();

    const handleToggle = (isOn: boolean) => {
        updateUserSetting({
            userId: user.id,
            settingName: Nut_Settings_User.SETTING_AI_FOLLOW_UP_TASKS_ENABLED,
            value: isOn ? '1' : '0',
            propertyOnUser: 'isAiFollowUpTasksEnabled',
        });
    };

    React.useEffect(() => {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_FOLLOW_UP_TASKS_ONBOARDING_VIEWED, {});
        handleToggle(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <OnboardingBody
            title='You said you’d do it – let Nutshell help you remember'
            isNutshellAi={true}
        >
            <div>
                <p>
                    Your calls and meetings are already being summarized. Nutshell can now turn
                    actionable items into tasks assigned to you.
                </p>
                <div className='flex align-center justify-between gap-12 mt-16'>
                    <Body isBold={true}>
                        Create follow-up tasks from summarized calls and meetings
                    </Body>
                    <Switch
                        isOn={user.isAiFollowUpTasksEnabled}
                        isRounded={true}
                        onChange={() => handleToggle(!user.isAiFollowUpTasksEnabled)}
                    />
                </div>
            </div>
        </OnboardingBody>
    );
}
